import { Outlet } from 'react-router';

import './root.css';

export { Layout } from './Layout.tsx';

export { ErrorBoundary } from './ErrorBoundary.tsx';

export default Outlet;
